function Overlay({ opacity = 0.04 }) {
  return (
    <div
      className="absolute inset-0 pointer-events-none z-0"
      style={{
        backgroundImage: "url('/cell.png')",
        backgroundRepeat: 'repeat',
        backgroundSize: '22px 32px',
        opacity: opacity,
      }}
    />
  )
}

export default Overlay
